import 'jquery-validation';

$(document).ready(function() {

    $('#contactForm').validate({
        success: function(label) {
            label.parent().addClass("success");
            label.remove();
        },
        highlight: function(element, errorClass) {
            $(element).parent().removeClass("success");
            $(element).addClass(errorClass);
        },
        errorElement: 'span',
        rules: {
            subject: "required",
            fullName: "required",
            number: {
                required: true,
                number: true
            },
            email: {
                required: true,
                email: true
            },
            company: "required",
            message: "required",
        },
        messages: {
            subject: "Please enter the subject of your message",
            fullName: "Please enter your full name",
            number: {
                required: "Please enter your telephone number",
                number: "You must enter a number"
            },
            email: {
                required: "Please enter your email address",
                email: "You must enter a valid email address"
            },
            company: "Please enter your company name",
            message: "Please enter your message"
        }
    });
},0);



// WEBPACK FOOTER //
// ./src/js/contact.js